
<h1 matDialogTitle class="row d-flex">
    <div class="col p-0">
      <div class="d-flex pt-3 ">
        <img [src]="labo?.logo" height="40" class="img" >
        <span class="align-self-center mx-2 h3 " style="color: rgb(7, 94, 151);  font-family: Arial !important; font-weight:bolder; ">
                  {{ labo?.name }}
        </span>
      </div>
    </div>
    <div class="col-7 p-0 d-none d-lg-block">
      <div class="col h3 text-left font-weight-bold border-left border-success my-1 " >
        <div class="text-success">
            Syst&egrave;me Informatis&eacute; de
        </div>
        <div class="text-info">
          Gestion des Laboratoires d'Analyses M&eacute;dicales
        </div>
      </div>
    </div>
</h1>


<mat-dialog-content style="overflow-y: hidden;">
  <div class="container-fluid font-weight-bold border">
    <form  [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="">
      <div class="row d-flex">
        <div class="col col-lg-5 align-self-center">
          <div class="col mb-5">
            <h3>CONNEXION</h3>
          </div>
          <div class="row">
              <div class="col-12">
                <mat-form-field class="mat-input-form">
                  <mat-label>username: </mat-label>
                  <input
                  value=""
                  type="username"
                  matInput
                  name="username"
                  formControlName="username"
                  >
                  <mat-icon class="mat-18" matSuffix>account_circle</mat-icon>
                  @if ((loginForm.get("username")?.touched || loginForm.get("username")?.dirty)&&
                  loginForm.get("username")?.hasError("required")
                    )
                    {
                      <mat-error>le username est requis</mat-error>
                    }
                </mat-form-field>
              </div>
              <div class="col-12 mt-2">
                <mat-form-field class="mat-input-form">
                  <mat-label>Password: </mat-label>
                  <input
                  value=""
                  type="password"
                  matInput
                  name="password"
                  formControlName="password"
                  ondrop="return false;"
                  onpaste="return false;"
                  (keydown.enter)="onSubmit()"
                  >
                  <mat-icon class="mat-18" matSuffix>password</mat-icon>
                  @if (loginForm.get("password")?.hasError("required")
                  && (loginForm.get("password")?.touched || loginForm.get("password")?.dirty))
                  {
                  <mat-error>le mot de passe est requis</mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-12 my-2 bouton">
                @if (submitted) {
                  <button type="submit" class="button" mat-raised-button  [disabled]="loginForm.valid">
                    <mat-spinner [diameter]="30" [color]="colorSpinner"></mat-spinner>
                  </button>
                }@else {
                  <button type="submit" class="button" mat-raised-button color="primary" [disabled]="loginForm.invalid">connexion</button>
                }
              </div>

              <div class="col-12">
                <a mat-flat-button class="link text-primary my-1" id="forgot-password" data-toggle="modal" data-target="#forgot-passbox">mot de passe oublié ?</a>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <span class="h4 m-4 text-info fab fa-facebook"></span>
                <span class="h4 m-4 text-info fab fa-google"></span>
                <span class="h4 m-4 text-info fab fa-twitter"></span>
                <span class="h4 m-4 text-info fab fa-linkedin"></span>
              </div>
          </div>
        </div>
        <div class="col col-lg-7 d-none d-lg-block p-0">
          <img class="img img-fluid w-100 h-100" src="assets/06.jpg" alt="image">
        </div>
      </div>
      <!---->
    </form>
  </div>
</mat-dialog-content>



<!-- forget password view -->

<div class="modal fade text-white " tabindex="-1" role="dialog" id="forgot-passbox" aria-hidden="true" aria-labelledby="forgot-password">
  <div class="modal-dialog modal-dialog-centered modal-lg " role="document">
      <div class="modal-content modalCustom">
          <div class="modal-header">
              <span class="modal-title h1 m-auto">
                  Mot de passe oublié  <span class="text-right fa fa-key"></span>
              </span>
          </div>
          <div class="modal-body" id="passbox">
            <!---->
              <div class="row my-2" *ngIf="!change_password.question">
                  <div class="col-10 m-auto" id="form-box">
                      <p>
                        Pour modifier votre mot de passe, vous devez donner la response à votre question secrete.
                        Veillez entrer votre nom pseudo pour retrouver votre question.
                      </p>
                      <mat-form-field  class="mat-input-forget" >
                        <mat-label>Pseudo</mat-label>
                        <input type="text"
                          matInput
                          name="fusername" id="fusername"
                          placeholder="Entrez votre pseudo"
                          [formControl]="pseudoControl"
                          >
                      </mat-form-field>
                      <mat-form-field  class="mat-input-forget" >
                        <mat-label>prenom</mat-label>
                        <input type="text"
                          matInput
                          name="fusername" id="fusername"
                          placeholder="Entrez votre pseudo"
                          [formControl]="prenomControl"
                          >
                      </mat-form-field>
                  </div>
              </div>

              <!---->
              <div class="row" id="reponse-box" *ngIf="change_password.question && !change_password.answer">
                  <span class="m-5"></span>
                  <div class="col-10 m-auto text-white" id="form-box">
                      Votre question.
                      <b class="bg-dark" id="question">{{ myAccount.question }}</b>
                  </div>
                  <div class="col-10 m-auto" id="form-box">
                      Essais restants:
                      <b class="text-warning h4" id="attempt">{{ count_answer_request }}</b>
                  </div>
                  <div class="col-10 m-auto" id="form-box">
                      <p class="my-2">
                        Veillez entrer la reponse à votre question.
                      </p>
                      <div >
                          <mat-form-field class="mat-input-forget">
                            <mat-label>Reponse</mat-label>
                            <input matInput
                            type="text"
                            name="reponse" id="reponse"
                            placeholder="Entrez votre reponse" autocomplete="off"
                            [formControl]="answerControl"
                            >
                          </mat-form-field>
                      </div>
                  </div>
              </div>

              <!---->
              <div class="row" id="pass-box" *ngIf="change_password.question && change_password.answer && !change_password.change">
                  <div class="col-10 m-auto">
                      <p class="h4 my-5">Vous pouvez maintenant creer un nouveau mot de passe.</p>
                      <form action="" [formGroup]="passwordForm">
                        <div  class="col" id="show_hide_password">
                          <mat-form-field appearance="fill" class="mat-input-forget">
                            <mat-label>Nouveau mot de passe</mat-label>
                            <input
                            matInput
                            type="password"
                            placeholder="Entrez le nouveau mot de passe"
                            formControlName="password">
                            <mat-icon matSuffix color="primary" (click)="showHiden()">visibility</mat-icon>
                          </mat-form-field>
                          <div class="text-danger">
                            @if(((passwordForm.get('password').hasError && passwordForm.get('password').touched) || passwordForm.get('password').dirty)){
                              @if(passwordForm.get('password').hasError('required')){<p>Le mot de passe est requis</p>}
                              @if(passwordForm.get('password').hasError('minlength')){<p> Le mot de passe doit avoir au moins 8 caractères</p>}
                              @if(passwordForm.get('password').hasError('formatError') && !passwordForm.get('password').hasError('required') &&
                              !passwordForm.get('password').hasError('minlength'))
                              {<p>Le mot de passe doit comprendre au moins une majscule, au moins un chiffre, au moins un caractère spécial <i>{{'Ex : Tests@10'}}</i> </p>}
                            }
                          </div>
                        </div>
                        <div class="m-2">
                          <mat-form-field class="mat-input-forget">
                            <mat-label>confirmer le mot de passe</mat-label>
                            <input matInput type="password"
                                  formControlName="confirmPassword"
                                  ondrop="return false;"
                                  onpaste="return false;">

                          </mat-form-field>
                          <div class="text-danger"
                                *ngIf="passwordForm.hasError('notSame')">
                                Les 2 champs ne correspondent pas
                            </div>
                        </div>
                      </form>
                  </div>
              </div>

          </div>

          <div class="modal-footer">
              <button mat-button class="bg-danger text-white" data-dismiss="modal" id="closer">Annuler</button>

              <button *ngIf="!change_password.question"
              mat-button class="bg-success text-white" id="confirmPseudo"
              (click)="findQuestion()"
              [disabled]="pseudoControl?.hasError('required')"
              >
              <mat-spinner *ngIf="loadingFP" [diameter]="30" color="accent">Envoi ...</mat-spinner>
              <span *ngIf="!loadingFP">Retrouver ma question</span>

              </button>

              <button *ngIf="change_password.question && !change_password.answer"
              mat-button class="bg-success text-white " id="confirmAnswer" (click)="giveAnswer()"
              [disabled]="answerControl?.hasError('required') || count_answer_request<1"
              >
                  <mat-spinner *ngIf="loadingFP" [diameter]="30" color="accent">Envoi ...</mat-spinner>
                  <span id="confirmAnswerTilte" *ngIf="!loadingFP">{{ btnMsg }}</span>
              </button>

              <button *ngIf="change_password.question && change_password.answer && !change_password.change"
                mat-button class="bg-success text-white " id="confirmChange" (click)="changePassword()"
                [disabled]="passwordForm.invalid"
                >
                  <mat-spinner *ngIf="loadingFP" [diameter]="30" color="accent">Changement ...</mat-spinner>
                  <span *ngIf="!loadingFP">changer mon mot de passe</span>
              </button>
          </div>
      </div>
    </div>
</div>
<!--
<div class="signin">
  <div class="signinForm">
    <h1 matDialogTitle> CONNEXION</h1>
    <mat-dialog-content>
      <form  [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="row col" >
                <mat-form-field >
                  <mat-label>username: </mat-label>
                  <input
                  value=""
                  type="username"
                  matInput
                  name="username"
                  formControlName="username"
                  >
                  @if ((loginForm.get("username")?.touched || loginForm.get("username")?.dirty)&&
                  loginForm.get("username")?.hasError("required")
                    )
                    {
                      <mat-error>le username est requis</mat-error>
                    }
                </mat-form-field>
        </div>
        <div class="row col mt-3">
              <mat-form-field >
                <mat-label>Password: </mat-label>
                <input
                value=""
                type="password"
                 matInput
                name="password"
                formControlName="password"
                >
                @if (loginForm.get("password")?.hasError("required")
                && (loginForm.get("password")?.touched || loginForm.get("password")?.dirty))
                {
                 <mat-error>le mot de passe est requis</mat-error>
                }
              </mat-form-field>
        </div>
        <div class="row col mt-3 mb-3 bouton">
          @if (loading) {
                <button type="submit" mat-raised-button  [disabled]="loginForm.valid">
                  <mat-spinner [diameter]="30" [color]="colorSpinner"></mat-spinner>
                </button>
            }@else {
                <button type="submit" mat-raised-button color="primary" [disabled]="loginForm.invalid">connexion</button>
            }
        </div>
        <a mat-button class="link text-primary" routerLink="">creer</a>
    </form>
    </mat-dialog-content>
  </div>
  <div class="signinImg bg-info">
    <img class="img-fluid  w-100 h-100" src="assets/06.jpg" alt="image">
  </div>
</div>
-->
